/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export function excludeSchema (payload) {
    const asArray = Object.entries(payload);
    const filtered = asArray.filter(
        ([key]) => key !== "schema"
    );

    const filteredPayload = Object.fromEntries(filtered);
    return filteredPayload;
}
